import Event from "./Event";
import Cache from "./Cache";

class Language extends Event {
    constructor() {
        super();
        this.wishlist = {};
        this.cacheDuration = 3600; // seconds
        this.promises = {
            fetching: null,
        };
        this.setUpdatedd = Date.now();
        this.cache = new Cache();

        this.apiURL = "";
        /* eslint-disable no-undef */
        if (process.env.NODE_ENV === "development") {
            this.apiURL = process.env.MIX_API_DEVELOPMENT ? process.env.MIX_API_DEVELOPMENT : "";
        } else {
            this.apiURL = process.env.MIX_API_PRODUCTION ? process.env.MIX_API_PRODUCTION : "";
        }
        /* eslint-enable no-undef */
    }

    // Creating a global instance
    static createInstance() {
        return new this();
    }

    /**
     * Update timestamp
     */
    setUpdated() {
        this.setUpdatedd = Date.now();
    }

    showLogin() {
        window.$("#myModal").modal("show");
    }

    /**
     * Fetch all items from wishlist
     *
     * Wishlist returns pending Promise if API request is pending or
     * returns cached data based on this.cacheDuration value
     *
     * @returns {Promise} Promise object with status and data
     */
    fetchOwnedBooks(type) {
        this.publish("itemsFetching");

        // If fetching is already underway we return promise
        if (this.promises.fetching) return this.promises.fetching;

        this.promises.fetching = fetch(this.apiURL + `/user/items?type=${type}`)
            .then((response) => {
                return response.text().then((text) => {
                    return {
                        status: response.status,
                        content: text,
                    };
                });
            })
            .then((response) => {
                let content = response.status < 300 ? JSON.parse(response.content) : null;

                if (content) {
                    this.setUpdated();
                    this.wishlist = content;
                }
                this.publish("itemsFetched", {
                    status: response.status,
                    content: content,
                });
                this.promises.fetching = null;

                return {
                    status: response.status,
                    content: content,
                };
            })
            .catch((error) => {
                this.setUpdated();
                this.promises.fetching = null;
                return {
                    status: 600,
                    error: error,
                };
            });

        return this.promises.fetching;
    }

    /**
     * Fetch all user points
     *
     * Points returns pending Promise if API request is pending or
     * returns cached data based on this.cacheDuration value
     *
     * @returns {Promise} Promise object with status and data
     */
    fetchPoints() {
        this.publish("pointsFetching");

        return fetch(this.apiURL + "/user/points")
            .then((response) => {
                return response.text().then((text) => {
                    return {
                        status: response.status,
                        content: text,
                    };
                });
            })
            .then((response) => {
                let content = response.status < 300 ? JSON.parse(response.content) : null;

                if (content) {
                    this.setUpdated();
                    this.wishlist = content;
                }
                this.publish("pointsFetched", {
                    status: response.status,
                    content: content,
                });

                return {
                    status: response.status,
                    content: content,
                };
            })
            .catch((error) => {
                this.setUpdated();
                return {
                    status: 600,
                    error: error,
                };
            });
    }
}

export default Language;
